<template>
  <!-- ヒーローセクションをスロットとして提供 -->
  <slot name="hero"></slot>

  <template v-if="isAllowed">
    <div v-if="announcements.length > 0" class="announcement-wrapper">
      <AnnouncementBanner
        v-for="item in announcements"
        :id="item.id"
        :key="item.id"
        :title="item.title"
      />
    </div>
  </template>

  <!-- メインコンテンツ -->
  <slot></slot>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
// メンテナンス情報表示用のコンポーネント
import { getAnnouncements } from '@/apis/announcement.api';
import AnnouncementBanner from '@/components/shared/announcement-banner/index.vue';
import type { AnnouncementData, AnnouncementDataFromAPI } from '@/types/announcement';

const route = useRoute();

const announcements = ref<AnnouncementData[]>([]);
const isAllowed = ref<boolean>(false);

const allowPath = (path: string): boolean => {
  return path === '/' || path === '/candidate/login';
};

const loadAnnouncements = async (): Promise<void> => {
  try {
    const res = await getAnnouncements();
    const combine: AnnouncementData[] = [
      ...(res.data.maintenance_announcements || []).map((a: AnnouncementDataFromAPI) => ({
        id: a.id,
        title: a.title,
        startDate: a.start_date,
      })),
      ...(res.data.general_announcements || []).map((a: AnnouncementDataFromAPI) => ({
        id: a.id,
        title: a.title,
        startDate: a.start_date,
      })),
    ];
    announcements.value = combine;
  } catch (error) {
    console.error('お知らせ情報の取得に失敗しました', error);
  }
};

watch(
  () => route.path,
  async (newPath) => {
    const allowed = allowPath(newPath);
    isAllowed.value = allowed;
    if (allowed) {
      if (announcements.value.length === 0) {
        await loadAnnouncements();
      }
    } else {
      announcements.value = [];
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.announcement-wrapper {
  width: 100%;
}

.announcement-wrapper .announcement-container {
  margin-bottom: 16px;
}
</style>
